import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }


  widgetReady:boolean = true;

  /* Date */
  dateRange: any = null;
  onDashDataChange(e=900) {
    this.widgetReady=false;
    setTimeout(()=>{this.widgetReady=true}, e);
  }


  /* COLOR SCHEMES (Charts) */
  colorSchemes = [
    { name: 'Default Blue', value: ['#70B9E1',  '#7396A8', '#70AAC6', '#5EA0D1', '#92BED8', '#A7CDE8'] },
    { name: 'Cool', value: ['#A8385D', '#7AA3E5', '#A27EA8', '#AAE3F5', '#ADCDED', '#A95963', '#8796C0', '#7ED3ED', '#50ABCC', '#AD6886'] },
    { name: 'Forest', value: ['#55C22D', '#C1F33D', '#3CC099', '#AFFFFF', '#8CFC9D', '#76CFFA', '#BA60FB', '#EE6490', '#C42A1C', '#FC9F32'] },
    { name: 'Horizon', value: ['#2597FB', '#65EBFD', '#99FDD0', '#CB96E8', '#FCEE4B', '#FDD6E3', '#FCB1A8', '#EF6F7B', '#EFDEE0', '#FEFCFA'] },
    { name: 'Vivid', value: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA', '#9370DB'] },
    { name: 'Greys', value: ['#647c8a', '#3f51b5', '#2196f3', '#00b862', '#afdf0a', '#a7b61a', '#f3e562', '#ff9800', '#ff5722', '#ff4514'] },
    { name: 'Blues Hues', value: ['#006997', '#275B73', '#315263', '#0B669F', '#1F475C', '#3E6377'] },
  ];
  colorSchemesNames = [ 'Default Blue', 'Cool', 'Forest', 'Horizon', 'Vivid', 'Greys', 'Blues Hues' ];
  colorSchemesArray  = [
    // 0 Blues Hues LIGHT (custom)
    ['#70B9E1',  '#7396A8', '#70AAC6', '#5EA0D1', '#92BED8', '#A7CDE8'],
    // 1 Cool
    ['#A8385D', '#7AA3E5', '#A27EA8', '#AAE3F5', '#ADCDED', '#A95963', '#8796C0', '#7ED3ED', '#50ABCC', '#AD6886'],
    // 2 Forest
    ['#55C22D', '#C1F33D', '#3CC099', '#AFFFFF', '#8CFC9D', '#76CFFA', '#BA60FB', '#EE6490', '#C42A1C', '#FC9F32'],
    // 3 Horizon
    ['#2597FB', '#65EBFD', '#99FDD0', '#CB96E8', '#FCEE4B', '#FDD6E3', '#FCB1A8', '#EF6F7B', '#EFDEE0', '#FEFCFA'],
    // 4 Vivid
    ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA', '#9370DB'],
    // 5 Greys
    ['#647c8a', '#3f51b5', '#2196f3', '#00b862', '#afdf0a', '#a7b61a', '#f3e562', '#ff9800', '#ff5722', '#ff4514'], // vivid
    // 6 Blues Hues (custom)
    ['#006997', '#275B73', '#315263', '#0B669F', '#1F475C', '#3E6377'],
  ];
  colorScheme = {
    name: 'horizon',
    selectable: true,
    group: 'Continuous',
    domain: this.colorSchemesArray[5], //greys
  };

  colorSchemeTempModel:any = [];
  colorSchemeModelChange() {
    let temp = this.colorScheme;
    temp['domain'] = this.colorSchemes[this.colorSchemeTempModel].value;
    this.colorScheme = Object.assign(temp,{});
    this.onDashDataChange(900); /* Reload */
  }


  colorSchemeCARDS = {
    domain: ['#5AA454', '#1890ff', '#A10A28', '#EEEEEE']
  };
  dataCARDS: any[] = [
    {
      "name": "Claims",
      "value": 531,
      "breakup": [
        {key: "New", value: "233"},
        {key: "Carried Forward", value: "‭298‬"},
      ]
    },
    {
      "name": "Adjudication",
      "value": 116,
      "breakup": [
        {key: "Pending Referral", value: "97"},
        {key: "Pending Investigation", value: "19"},
      ]
    },
    {
      "name": "Investigation",
      "value": 98
    },
    {
      "name": "Payout",
      "value": 102
    },
    {
      "name": "Completed",
      "value": 211
    },
  ];


  /* Data */
  dataSet = [
    {
      name : 'John Brown',
      claimValue : '42,50,800',
      tasks: 12,
      completed: 5,
      pendingInt: 2,
      pendingAdj: 2,
      pendingPay: 3,
      sla: 5,
    },
    {
      name : 'Evan Green',
      claimValue : '42,50,800',
      tasks: 15,
      completed: 5,
      pendingInt: 2,
      pendingAdj: 1,
      pendingPay: 2,
      sla: 6
    },
    {
      name : 'Evan John',
      claimValue : '42,50,800',
      tasks: 11,
      completed: 2,
      pendingInt: 2,
      pendingAdj: 1,
      pendingPay: 2,
      sla: 6
    },
    {
      name : 'Nimrod T',
      claimValue : '42,50,800',
      tasks: 21,
      completed: 15,
      pendingInt: 2,
      pendingAdj: 1,
      pendingPay: 2,
      sla: 6
    },
    {
      name : 'Jane Red',
      claimValue : '42,50,800',
      tasks: 18,
      completed: 9,
      pendingInt: 2,
      pendingAdj: 1,
      pendingPay: 2,
      sla: 6
    },
  ];

  /* Investigator */
  dataCARDSInvestigator: any[] = [
    {
      "name": "Claims under investigation",
      "value": 121,
      "breakup": [
        {key: "Full Investigation", value: "32"},
        {key: "Basic Investigation", value: "‭18‬"},
        {key: "Document collection", value: "‭22‬"},
        {key: "Source Verification", value: "12‬"},
        {key: "Health claim investigation", value: "‭16‬"},
      ]
    },
    {
      "name": "Sub categories",
      "value": null,
      "breakup": [
        {key: "Hospital/Clinic Check", value: "23‬"},
        {key: "Nominee Check", value: "27"},
        {key: "Neighbour Checks", value: "‭16‬"},
        {key: "Employer Check", value: "‭22‬"},
        {key: "Anganwadi Check", value: "12‬"},
      ]
    },
  ];

  /* DUMMY ; change logic */
  getUserLoad(u) {
    if(u.completed/u.tasks*100 < 40) return 'low';
    else if(u.completed/u.tasks*100 < 60) return 'med';
    else return 'hig';
  }

  /* Search */
  searchTerm:string = '';

  /* Agent Search -- FAKE */
  isSearching = false;
  agentSearch() {
    this.isSearching = true;
    this.dataSet = this.Shuffle(this.dataSet); /* Fake sort */
    this.dataSet = this.dataSet.sort(() => Math.random() - 0.15 ); /* Fake sort */
    setTimeout(()=>{this.isSearching = false;},800);
  }
  Shuffle(o) {
    for(var j, x, i = o.length; i; j = parseInt(String(Math.random() * i)), x = o[--i], o[i] = o[j], o[j] = x);
    return o;
  };



  /* Toggle */
  persona: string = 'staff';



  pie = [
    {
      "name": "Life",
      "value": 40632,
      "extra": {
        "code": "de"
      }
    },
    {
      "name": "Health",
      "value": 50000,
      "extra": {
        "code": "us"
      }
    },
    {
      "name": "Motor",
      "value": 36745,
      "extra": {
        "code": "fr"
      }
    },
    {
      "name": "Travel",
      "value": 36240,
      "extra": {
        "code": "uk"
      }
    },
  ];



  onSelect(e) {
    console.log('ngx-chart',e);
  }



  /* Size */
  view: any[] | undefined = undefined;

  gradient = false;
  showLegend = false;

  showXAxis = true;
  showXAxisLabel = true;
  showYAxis = true;
  showYAxisLabel = true;
  timeline = false;

  single = [
    {
      "name": "Sanjay K",
      "value": 11
    },
    {
      "name": "Manish S",
      "value": 19
    },
    {
      "name": "Rahul R",
      "value": 9
    },
    {
      "name": "Kamlesh T",
      "value": 13
    },
    {
      "name": "Nupur K T",
      "value": 8
    },
    {
      "name": "Sumit K",
      "value": 21
    },
  ];





}
